import React from "react";
import { motion } from "framer-motion";
import img from "../../Assets/img/Events/whoweare1.JPG";
import img2 from '../../Assets/img/Events/whoweare2.JPG'
import banner from "../../Assets/img/banner2.avif";
import './about.css';
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import PublicHeader from "../Header/PublicHeader";

const WhoWeAre = () => {
  const navigate = useNavigate();
  const handleContact = () => {
    navigate('/membership'); // Navigate to membership page
  };
  return (
    <>
          <PublicHeader />

    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="about-us mx-auto"
    >
      {/* Section Header */}
      <div
        className="section-header md:mt-[40px] mt-0"
      >
        <div className="header-content px-5">
            <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
           
          >
            <h1 className="text-4xl md:text-6xl display-4 fw-bold text-center text-white">Who we are</h1>
            
          </motion.div>
        </div>
       
      </div>
      {/* <h3 className="text-3xl md:text-5xl font-bold text-gray-800 text-center my-12 ">Who we are</h3> */}
      {/* Who We Are Section */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className="grid1 container md:grid1-cols-2 gap-16 mt-4" 
      >
        {/* Text Content */}
        <div className="p-6  bg-white mb-10 lg:p-10"style={{border:"1px solid #E5F4F2",height:"fit-content", borderRadius:"20px", boxShadow: "34.8541px 29.626px 48.34px rgba(51, 102, 255, 0.05)"}}>
         
          <p className="text-lg text-gray-700  leading-relaxed text-justify mx-auto" style={{ textWrap: 'pretty' }}>
            The
            <strong>
              {" "}
              Association of Professional Career Counsellors of India{" "}
            </strong>
            (APCCI) is a<strong> Non-profit organization</strong> headquartered
            at New Delhi, India
            <strong>
              {" "}
              registered under Section 8 of the Companies Act 2013
            </strong>
            , dedicated to supporting career counsellors across the country.
            Over the past  
            <strong> three years</strong>, APCCI has grown into a recognised
            <strong>
              {" "}
              National Platform for Career counselling Professionals{" "}
            </strong>
            driven by the shared vision, commitment, and collective efforts of its 
            members.
            <br />
            <br />
            Since its inception, APCCI has evolved into a structured and inclusive professional 
            community where career counsellors connect, collaborate, learn, and grow together. 
            Built on the principles of ethics, professionalism, and continuous learning, APCCI 
            serves as a common platform for advancing the practice of career counselling in India.
            <br />
            <br />
            Today, APCCI offers its members valuable services such as professional development through 
            training and certification, networking opportunities through events, and access to the 
            latest research and insights in career counselling. It also advocates for the profession 
            and promotes ethical and professional standards to help strengthen and elevate the career 
            counselling ecosystem in India.
            <br />
            <br />
            Despite its growth, APCCI remains true to its founding values - {" "}
            <strong>a democratic community driven by counsellors</strong>, for
            counsellors. Every member is part of this evolving journey,
            contributing to making career counselling more professional,
            impactful, and accessible nationwide. If you're a career counsellor
            looking for a community that supports your growth and strengthens
            your professional practice, 
            <strong> APCCI welcomes you. Join us and become part of India's growing movement 
              towards professional, ethical, and future-ready career guidance.</strong>.
          </p>
        </div>

        {/* Animated Image */}
       {/* Animated Images - Two Rows */}
<motion.div
  className="relative flex flex-col    overflow-hidden w-full "
  style={{ height: "80%", borderRadius:"20px" }} // Ensuring it takes full height of the text
>
  <motion.img
    
    src={img}
    alt="APCCI Team 1"
    className="w-full object-cover h-1/2 rounded-lg mb-10"
  />
  <motion.img
   
    src={img2} // Replace with second image
    alt="APCCI Team 2"
    className="w-full object-cover h-1/2 rounded-lg"
  />
</motion.div>

      </motion.div>     

      {/* Call to Action Section */}
      <div className="cta-section text-center py-16 ">
        <motion.h3
          className="text-4xl font-bold mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          Ready to Make a Difference?
        </motion.h3>
        <p className="text-lg mb-8 max-w-2xl mx-auto">
          Join the APCCI community and help shape the future of career
          counselling in India.
        </p>
        <motion.button
          whileHover={{ scale: 1.1 }}
          className="cta-button"
          onClick={handleContact}
        >
          Get Started Now
        </motion.button>
      </div>
    </motion.div>
    <Footer/>
    </>
  );
};

export default WhoWeAre;